import notification from 'ant-design-vue/es/notification'
import { i18nRender } from '@/locales'
import CryptoJS from 'crypto-js'
import store from '../store/index.js'

export function isIE () {
  const bw = window.navigator.userAgent
  const compare = (s) => bw.indexOf(s) >= 0
  const ie11 = (() => 'ActiveXObject' in window)()
  return compare('MSIE') || ie11
}

export function getPane (menu, activeKey) {
  const { childMenus, menuId, menuName, menuUrl } = menu
  let pane = null
  let flag = true

  if (childMenus && childMenus.length > 0) {
    childMenus.forEach(item => {
      !pane && (pane = getPane(item, activeKey))

      if (pane && flag) {
        pane.breadList.unshift(item.menuName)
        flag = false
      }
    })
  } else {
    pane = menuId === activeKey
      ? { key: menuId, tab: menuName, path: menuUrl, breadList: [menuName], closable: true }
      : null
  }

  return pane
}

export function getObjBykeys (obj, keys = [], initialValue = {}) {
  const value = {}
  keys.forEach(key => {
    value[key] = obj[key] || undefined
  })
  return { ...value, ...initialValue }
}

export function findPane (menus = [], target, config = {}, plusPaneKeys = [], childKey = ['childMenus'], parent = null, deep = 0) {
  if (!menus || !menus.length) return undefined
  let pane
  const targetKeys = Object.keys(target)
  const targetString = JSON.stringify(target)
  const defaultConfig = { closable: true }
  config = { ...defaultConfig, ...config }

  menus.forEach(menu => {
    const menuObject = getObjBykeys(menu, targetKeys)
    const menuString = JSON.stringify(menuObject)
    const childs = childKey.reduce((acc, cur) => Array.isArray(menu[cur]) ? [...acc, ...menu[cur]] : acc, [])
    if (pane) {

    } else if (targetString === menuString) {
      console.log('menu', menu)
      pane = { ...getObjBykeys(menu, plusPaneKeys, { ...config }), parent }
    } else if (childs?.length) {
      pane = findPane(childs, target, { ...config, deep: deep + 1 }, plusPaneKeys, childKey, menu, deep + 1)
    }
  })

  return pane
}

/**
 * @description: 下载文件
 * @param {blob=*} data blob元数据
 * @param {string=*} name 文件名称
 * @param {string} type 文件类型
 */
export function downloadFn (data, name, type) {
  if ('download' in document.createElement('a')) { // 非IE下载
    let merge = data
    if (data instanceof Blob && type) {
      merge = new Blob([data], { type })
    }
    const elink = document.createElement('a')
    elink.download = isFirefox() ? name.substring(0, name.lastIndexOf('.')) : name
    elink.style.display = 'none'
    elink.href = window.URL.createObjectURL(merge)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL对象
    document.body.removeChild(elink)
  } else { // IE10+下载
    navigator.msSaveBlob(data, name)
  }
}

export function isFirefox () {
  const userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
  return userAgent.indexOf('Firefox') > -1
}

// 警告弹窗
export function openNotificationWithIcon (text) {
  notification.warning({
    message: i18nRender('common_globalcomp_warm_prompt'),
    description: text
  })
}

var timer = null
export function debounce (fn, delay) {
  return (function () {
    if (timer !== null) {
      clearTimeout(timer)
    }
    timer = setTimeout(fn, delay)
  })()
}

// 针对不同环境下的域名拿值
export function oneValues () {
  var query = window.location.href
  query = query.split('?')
  var params = {}
  for (let i = 0; i < query.length; i++) {
    let q = query[i].split('=')
    if (q.length === 2) {
      params[q[0]] = q[1]
    }
  }
  return params // 返回?号后面的参数名与参数值的数组
}

// AES加密
export function encrypt (word, keyStr = 'rhnmdud7trabrta1') {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  let key = CryptoJS.enc.Utf8.parse(keyStr)
  let iv = CryptoJS.enc.Utf8.parse('1131100000022322')
  let encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv })
  return encrypted.toString()
}

// AES解密
export function decrypt (word, keyStr = 'rhnmdud7trabrta1') {
  let key = CryptoJS.enc.Utf8.parse(keyStr)
  let iv = CryptoJS.enc.Utf8.parse('1131100000022322')
  let decrypt = CryptoJS.AES.decrypt(word, key, { mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7, iv })
  return CryptoJS.enc.Utf8.stringify(decrypt).toString()
}

export function isShowMeun (name, val) {
  // console.log(store.state.isLogin)
  for (let item in store.state.isLogin.childMenu) {
    if (store.state.isLogin.childMenu[item].menuName === name) {
      for (let key in store.state.isLogin.childMenu[item].funcArray) {
        if (store.state.isLogin.childMenu[item].funcArray[key] === val) {
          return true
        } else {
          return false
        }
      }
    } else {
      return false
    }
  }
}

export function deepSearchField (target, options = {}) {
  if (options.reg && options.reg.test(target?.[options.props])) {
    return target
  } else {
    return target[options.children] ? deepSearchField(target[options.children], options) : null
  }
}

export function scrollToError (el, className) {
  const scrollOption = {
    behavior: 'smooth',
    block: 'center'
  }
  const isError = document?.getElementsByClassName(className)
  isError[0]?.scrollIntoView(scrollOption)
}
